import { Box, Typography } from "@mui/material";
import { displayFont } from "../../../styles/theme";

const parts = [
  { word: "Grow", meaning: "crescer, evoluir e ir além" },
  { word: "Groove", meaning: "ritmo, balanço e identidade" },
];

function WordCard({ word, meaning, highlight = false }) {
  return (
    <Box
      sx={{
        p: { xs: 4, md: 5 },
        height: "100%",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        textAlign: "center",
        borderRadius: 4,
        border: "1px solid",
        borderColor: highlight ? "primary.main" : "divider",
        bgcolor: highlight ? "rgba(207, 167, 90, 0.08)" : "rgba(255, 255, 255, 0.02)",
      }}
    >
      <Typography sx={{ fontFamily: displayFont, fontSize: { xs: "2.25rem", md: "2.75rem" }, color: highlight ? "primary.main" : "text.primary", lineHeight: 1.1 }}>
        {word}
      </Typography>
      <Typography sx={{ mt: 1, color: "text.secondary", fontSize: 14, letterSpacing: "0.04em" }}>{meaning}</Typography>
    </Box>
  );
}

function Operator({ children }) {
  return (
    <Typography aria-hidden="true" sx={{ alignSelf: "center", fontFamily: displayFont, fontSize: 40, color: "primary.main", textAlign: "center", lineHeight: 1 }}>
      {children}
    </Typography>
  );
}

export function NameOrigin() {
  return (
    <Box component="section">
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr auto 1fr auto 1.2fr" },
          alignItems: "stretch",
          gap: { xs: 2, md: 3 },
          maxWidth: 1000,
          mx: "auto",
        }}
      >
        <WordCard {...parts[0]} />
        <Operator>+</Operator>
        <WordCard {...parts[1]} />
        <Operator>=</Operator>
        <WordCard word="Groowv" meaning="crescer através da música" highlight />
      </Box>

      <Typography
        sx={{
          mt: { xs: 6, md: 8 },
          mx: "auto",
          maxWidth: 760,
          textAlign: "center",
          color: "text.secondary",
          fontSize: { xs: "1.05rem", md: "1.2rem" },
          lineHeight: 1.8,
        }}
      >
        A{" "}
        <Box component="strong" sx={{ color: "primary.main", fontWeight: 600 }}>
          Groowv
        </Box>{" "}
        nasceu da união de duas ideias: Grow, que significa crescer, evoluir e ir além, e Groove, que representa o
        ritmo, o balanço e a identidade da nossa música. Dessa combinação surge o nosso propósito: crescer através da
        música, criando experiências marcantes e uma identidade sonora única.
      </Typography>
    </Box>
  );
}
